import React, { useState } from "react";
import { Container } from "..";
import { Accordion } from "../../../../../app/components";
import CustomRow from "../../../../../app/components/custom.tables.components/custom.row";
import CustomCell from "../../../../../app/components/custom.tables.components/custom.cell";
import CustomTooltip from "../../../../../app/components/tooltip/custom.tooltip";
import { useRestoreTableVisibility } from "../../hooks/useRestoreTableVisibility";
import { DATA_TABLE_NAME } from "../../constants";
import { toParticipantUiText } from "../../../../../app/utils/participantTerminology";

export default function EPriceTable({ data }) {
  const [isExpanded, setIsExpanded] = useState(false);

  useRestoreTableVisibility('EPriceTable', setIsExpanded);

  const renderTable = () => {
    return data.map((d, idx) => {
      return (
        <CustomRow key={idx}>
          <CustomCell
            variant="header"
            justify="flex-end"
            width="30%"
            textAlign="right"
            style={{
              borderBottom: "none",
            }}
          >
            {toParticipantUiText(d.rowLabel)}
          </CustomCell>
          <CustomCell width="70%">
            <CustomTooltip title={d.cellValue1?.toString() || ''}>
              <div>{d.cellValue1}</div>
            </CustomTooltip>
          </CustomCell>
        </CustomRow>
      );
    });
  };

  return (
    <Accordion
      scrollIntoView={true}
      width={"100%"}
      summary={"Study Specs"}
      defaultExpanded={isExpanded}
      onChange={(_, expanded) => setIsExpanded(expanded)}
      data-table-name={DATA_TABLE_NAME.EPRICE_TABLE}
    >
      <Container 
        onClick={(e) => e.stopPropagation()} 
        data-table-name={DATA_TABLE_NAME.EPRICE_TABLE}
        data-table-container="true"
      >
        {renderTable()}
      </Container>
    </Accordion>
  );
}
